import { useEffect, useState } from 'react';
import api from './api';

export const TOKEN_KEY = 'admin_token';
export const USER_KEY = 'admin_user';
export const PERMISSION_KEYS = [
  'can_create_events',
  'can_publish_events',
  'can_manage_locali',
  'can_view_stats',
  'can_manage_newsletter',
];

export function setAuth(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event('auth-changed'));
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.dispatchEvent(new Event('auth-changed'));
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function isAuthenticated() {
  return !!getToken();
}

export function hasPermission(perm) {
  const u = getUser();
  if (!u) return false;
  if (u.is_super_admin) return true;
  return !!(u.permissions && u.permissions[perm]);
}

export function isSuperAdmin() {
  return !!getUser()?.is_super_admin;
}

// React hook that re-renders when auth changes (and refreshes /me on mount)
export function useUser() {
  const [user, setUser] = useState(() => getUser());
  useEffect(() => {
    const handler = () => setUser(getUser());
    window.addEventListener('auth-changed', handler);
    window.addEventListener('storage', handler);
    // refresh from server
    if (getToken()) {
      api.get('/auth/me').then((r) => {
        if (r.data) {
          localStorage.setItem(USER_KEY, JSON.stringify(r.data));
          setUser(r.data);
        }
      }).catch(() => {});
    }
    return () => {
      window.removeEventListener('auth-changed', handler);
      window.removeEventListener('storage', handler);
    };
  }, []);
  return user;
}
